export enum ConversationStatus {
  IDLE = 'idle',
  ONGOING = 'ongoing',
  ONGOING_WAITING = 'ongoing_waiting',
  FINISHED = 'finished',
}

export enum ConversationEndReason {
  SUCCESS = 'success',
  OPERATOR_REQUESTED = 'operator_requested',
  NOT_RECOGNIZED = 'not_recognized',
}

export interface InstantAnswersPlaygroundState {
  sessionId: string | null
  status: ConversationStatus
  endReason: ConversationEndReason | null
  messages: Message[]
}

export const InstantAnswersPlaygroundInitialState: InstantAnswersPlaygroundState = {
  sessionId: null,
  status: ConversationStatus.IDLE,
  endReason: null,
  messages: [],
}

export enum InstantAnswersSocketEvent {
  SCENARIO_NOT_RECOGNIZED = 'ai_automation_scenario_not_recognized',
  MESSAGE_GENERATED = 'ai_automation_message_generated',
  SESSION_FINISHED = 'ai_automation_session_finished',
}

interface SystemMessage {
  type: 'system'
  author: 'ai'
  data: {
    text: string
  }
}

interface TextMessage {
  type: 'text'
  author: 'user' | 'ai'
  data: {
    text: string
  }
}

export type Message = TextMessage | SystemMessage
